// extracted by mini-css-extract-plugin
export var fill = "video-module--fill--c4ebd";
export var frame = "video-module--frame--1a590";
export var normal = "video-module--normal--4b5bc";
export var wrapper = "video-module--wrapper--421f5";